module.exports = __webpack_public_path__ + "img/mobile-index-Vticket.f7563bd1.png";